import { useQuery } from "@/api/utils/useQuery"
import { HasuraQueries } from "@/api/hasura/queries"
import { QueryResult } from "@/api/utils/types"
import { WarrantsFilesJobParser } from "@/models/admin/warrantsFilesJob/warrantsFilesJob.parser"
import { IWarrantsFilesJob } from "@/models/admin/warrantsFilesJob/warrantsFilesJob.types"
import {
  Financials_Warrants_Files_Job_Bool_Exp,
  Financials_Warrants_Files_Job_Order_By,
  GetWarrantsFilesJobsQuery,
} from "@/api/hasura/generated/graphql"

export interface WarrantsFilesJobListResult {
  jobs: IWarrantsFilesJob[]
  totalCount: number
}

class WarrantsFilesJobServiceClass {
  getJobs(
    search: string,
    page: number,
    pageSize: number,
    orderBy: Financials_Warrants_Files_Job_Order_By,
  ): QueryResult<WarrantsFilesJobListResult> {
    // Jobs are searched by their numeric ID. A non-numeric search can never
    // match a bigint id, so fall back to a sentinel that returns no rows.
    const where: Financials_Warrants_Files_Job_Bool_Exp = {}
    const trimmed = search.trim()
    if (trimmed) {
      where.id = { _eq: /^\d+$/.test(trimmed) ? trimmed : -1 }
    }

    return useQuery({
      ...HasuraQueries.warrants.filesJobs(
        (page - 1) * pageSize,
        pageSize,
        where,
        orderBy,
      ),
      useRawResponse: true,
      placeholderData: { jobs: [], totalCount: 0 },
      parserFn: (
        data: GetWarrantsFilesJobsQuery,
      ): WarrantsFilesJobListResult => ({
        jobs: data.financials_warrants_files_job.map(
          WarrantsFilesJobParser.toDomain,
        ),
        totalCount:
          data.financials_warrants_files_job_aggregate.aggregate?.count ?? 0,
      }),
    })
  }
}

export const WarrantsFilesJobService = new WarrantsFilesJobServiceClass()
